import React from "react";
import { BillingBanner } from "../../../components/billing/BillingBanner";
import { DashboardPageLayout } from "../../../components/layout/DashboardPageLayout";
import { HomeProductShortcuts } from "../../../components/dashboard/HomeProductShortcuts";
import { ButtonLink } from "../../../components/ui/button";
import type { MainAppPageProps } from "../types";

type ProductsHomePageProps = Pick<
  MainAppPageProps,
  "routes" | "hasJobSitePhotos" | "hasCredentials" | "billing"
>;

export const ProductsHomePage: React.FC<ProductsHomePageProps> = ({
  routes,
  hasJobSitePhotos = false,
  hasCredentials = false,
  billing,
}) => {
  const websiteSetupPath =
    routes.organizationWebsiteSetup ?? "/organization/website";
  const jobsHref = routes.dashboardJobs ?? "/dashboard/jobs";
  const credentialsHref =
    routes.dashboardCredentials ?? "/dashboard/credentials";
  const billingRoute = routes.billing ?? "/dashboard/billing";

  return (
    <DashboardPageLayout
      title="Home"
      subtitle="Your company is set up. Create a website when you are ready, or open Jobs and Credentials now."
      headerActions={
        <ButtonLink to={websiteSetupPath} variant="premium">
          Create your website
        </ButtonLink>
      }
    >
      <BillingBanner billing={billing} billingRoute={billingRoute} />
      <HomeProductShortcuts
        jobsHref={jobsHref}
        credentialsHref={credentialsHref}
        showWebsite
        showJobs={hasJobSitePhotos}
        showCredentials={hasCredentials}
      />
    </DashboardPageLayout>
  );
};
